import React from 'react';
import PropTypes from 'prop-types';
import BrowserUtils from '../../utils/BrowserUtils';
import _ from 'lodash';
import StringConstant from '../../constants/StringConstants';
import PayeeAccountCardInfo from './PayeeAccountCardInfo';
import AccountsStore from '../../stores/AccountsStore';
import UserManagementStore from '../../stores/UserManagementStore';
import MoveMoneyBL from './MoveMoneyBL';

let isNominatedUser = false;

class PayeeListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.onPayeeClick = this.onPayeeClick.bind(this);
    this.getFilteredAndSortedPayeeList =
      this.getFilteredAndSortedPayeeList.bind(this);
    this.onInputSearchChange = this.onInputSearchChange.bind(this);
    this.clearclick = this.clearclick.bind(this);
    this.cancelTransactionSearch = this.cancelTransactionSearch.bind(this);
    this.showAddPayeePage = this.showAddPayeePage.bind(this);
    this.editClickFromPayee = this.editClickFromPayee.bind(this);
    this.deletePayeeClick = this.deletePayeeClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.checkKeyPress = this.checkKeyPress.bind(this);
    this.showMoreClick = this.showMoreClick.bind(this);
    this.renderpayeeShowMoreButton = this.renderpayeeShowMoreButton.bind(this);
    this.showMoreKeyPress = this.showMoreKeyPress.bind(this);
    const payeeCount = BrowserUtils.isMobileView()
      ? this.props.payeeList.beneficiaries !== undefined
        ? this.props.payeeList.beneficiaries.length
        : 0
      : 9;
    this.state = {
      inputValue: '',
      payeeCount,
      hasPayeeCount: false,
      getAccounts: AccountsStore.getAccounts(),
    };
  }

  componentWillMount() {
    isNominatedUser = UserManagementStore.isNominatedUser();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.payeeList.beneficiaries && !this.state.hasPayeeCount) {
      this.state.hasPayeeCount = true;
      const payeeCount = BrowserUtils.isMobileView()
        ? this.props.payeeList.beneficiaries !== undefined
          ? this.props.payeeList.beneficiaries.length
          : 0
        : 9;
      this.setState({
        payeeCount,
      });
    }
  }

  // In Progress----
  onInputSearchChange(e) {
    const value = e.target.value;
    this.setState({ inputValue: value });
  }

  onPayeeClick(selectpayeedata) {
    this.props.onPayeeClick(selectpayeedata);
  }

  getFilteredAndSortedPayeeList() {
    let payeeList = this.props.payeeList.beneficiaries;
    this.state.payeeLength = this.props.payeeList.beneficiaries.length;
    if (this.state.inputValue.length > 2) {
      const inputLowerCase = this.state.inputValue.toLowerCase();

      const payees = payeeList.filter((payee) => {
        return (
          _.includes(
            payee.to_account.name.toString().toLowerCase(),
            inputLowerCase
          ) ||
          _.includes(
            payee.display_name.toString().toLowerCase(),
            inputLowerCase
          )
        );
      });
      payeeList = payees;
      this.state.payeeLength = payees.length;
    }
    payeeList = payeeList.slice(0, this.state.payeeCount);
    return payeeList;
  }

  getSVGIcon() {
    return (
      <span>
        <svg
          style={{ pointerEvents: 'none' }}
          width="32px"
          height="32px"
          viewBox="0 0 48 48"
          role="img"
        >
          <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-1652.000000, -210.000000)" fill="#000">
              <g transform="translate(167.000000, 200.000000)">
                <path
                  d="M1508.99962,55.0007031 C1497.40144,55.0007031 1488.00005,45.5993062 1488.00005,34.000375 C1488.00005,22.4014438 1497.40144,13.0000469 1508.99962,13.0000469 C1520.59781,13.0000469 1529.99995,22.4014438 1529.99995,34.000375 C1529.99995,45.5993062 1520.59781,55.0007031 1508.99962,55.0007031 M1508.99962,10 C1495.74467,10 1485,20.7446679 1485,34.000375 C1485,47.2560821 1495.74467,58.00075 1508.99962,58.00075 C1522.25458,58.00075 1533,47.2560821 1533,34.000375 C1533,20.7446679 1522.25458,10 1508.99962,10 M1510.4644,32.5356021 L1510.4644,24.2209722 C1510.46515,23.4124596 1509.80889,22.7561993 1508.99962,22.7561993 C1508.19111,22.7561993 1507.53485,23.4124596 1507.53485,24.2209722 L1507.53485,32.5356021 L1499.22022,32.5356021 C1498.41171,32.5356021 1497.75545,33.1903623 1497.75545,34.000375 C1497.75545,34.8088876 1498.41171,35.4651479 1499.22022,35.4651479 L1507.53485,35.4651479 L1507.53485,43.7797778 C1507.53485,44.5882904 1508.19111,45.2445507 1508.99962,45.2445507 C1509.80889,45.2445507 1510.4644,44.5882904 1510.4644,43.7797778 L1510.4644,35.4651479 L1518.77903,35.4651479 C1519.58829,35.4651479 1520.2438,34.8088876 1520.2438,34.000375 C1520.2438,33.1903623 1519.58829,32.5356021 1518.77903,32.5356021 L1510.4644,32.5356021 Z"
                  id="icon-add"
                />
              </g>
            </g>
          </g>
        </svg>
      </span>
    );
  }

  cancelTransactionSearch(e) {
    e.preventDefault();
    this.refs.searchInput.value = '';
    this.setState({ inputValue: '' });
  }

  checkKeyPress(e) {
    if (
      e.target.tagName.toLowerCase() === 'li' ||
      e.target.tagName.toLowerCase() === 'button'
    ) {
      if (e.which === 40 || e.keyCode === 40) {
        if (document.activeElement.nextSibling) {
          document.activeElement.nextSibling.focus();
        }
      } else if (e.which === 38 || e.keyCode === 38) {
        if (document.activeElement.previousSibling) {
          document.activeElement.previousSibling.focus();
        }
      } else if (e.which === 13 || e.keyCode === 13) {
        this.showAddPayeePage(e);
      }
    }
  }

  clearclick(e) {
    e.preventDefault();
    this.refs.searchInput.value = '';
    //this.forceUpdate();
    this.setState({ inputValue: '' });
  }

  deletePayeeClick(data) {
    this.props.deletePayeeClick(data);
  }

  editClickFromPayee(data) {
    this.props.editClickFromPayee(data);
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      //const text = this.refs.searchInput.value;
    }
  }

  showAddPayeePage(e) {
    this.props.showAddPayeePage(e);
  }

  showMoreClick() {
    this.state.payeeCount += StringConstant.payeeLimitDesktop;
    this.setState({ payeeCount: this.state.payeeCount });
  }

  showMoreKeyPress(e) {
    MoveMoneyBL.showMoreFocusPrevElement(e, this.showMoreClick);
  }

  showPayees() {
    if (this.props.payeeList.beneficiaries !== undefined) {
      const payees = this.getFilteredAndSortedPayeeList();
      const payeeList = _.map(payees, (payee, index) => {
        const payeeComponent = (
          // This is to show the cards.
          <PayeeAccountCardInfo
            key={index}
            data={payee}
            index={index}
            onClick={this.onPayeeClick}
            delete={this.deletePayeeClick}
            editClick={this.editClickFromPayee}
          />
        );
        return payeeComponent;
      });
      return payeeList;
    }
  }

  renderpayeeShowMoreButton() {
    if (this.props.payeeList.beneficiaries !== undefined) {
      if (this.state.payeeCount < this.state.payeeLength) {
        return (
          <div>
            <li
              role="presentation"
              className="c-btn c-btn--link type--uist u-no-padding"
              onClick={this.showMoreClick}
              onKeyDown={this.showMoreKeyPress}
            >
              <button
                className="c-btn c-btn--link type--uist u-no-padding"
                tabIndex="-1"
              >
                Show more
              </button>
            </li>
          </div>
        );
      } else {
        return null;
      }
    }
    return null;
  }

  render() {
    // TODO Handle it later
    //  onKeyPress={this.handleKeyPress}
    //  onFocus={this.moveCaretAtEnd}
    // const classNN = isSearching ? 'focused' : '';

    // TODO Show MOre button functionality

    const classNN = this.state.inputValue ? 'focused' : '';

    return (
      <div className={this.props.payeeClass}>
        <ul
          role="listbox"
          aria-labelledby="whoYouPay"
          className="account-card-list__payee-list"
        >
          <div className="account-card-list__payee-list__header">
            <h3 className="account-card-list__type" id="whoYouPay">
              {this.props.content.newPayee}
            </h3>
            {this.props.payeeList.beneficiaries !== undefined &&
            this.props.payeeList.beneficiaries.length > 0 ? (
              <div className="search-payee">
                <form action="." className="autofillSearch">
                  <input
                    id="timelineSearch"
                    type="search"
                    placeholder="Search"
                    value={this.state.inputValue}
                    ref="searchInput"
                    onChange={this.onInputSearchChange}
                    onKeyPress={this.handleKeyPress}
                    className={`type--jura ${classNN}`}
                    autoComplete="off"
                    minLength={2}
                  />
                  {this.refs.searchInput &&
                  this.refs.searchInput.value.length > 0 ? (
                    <div>
                      <a
                        href="javascript:;"
                        tabIndex="-1"
                        className="searchClear icon icon-clear"
                        aria-label="Clear Search"
                        onClick={this.clearclick}
                      />
                      <a
                        href="javascript:;"
                        tabIndex="-1"
                        className="search-cancel opt-green"
                        aria-label="Cancel Search"
                        onClick={this.cancelTransactionSearch}
                      >
                        Cancel
                      </a>
                    </div>
                  ) : (
                    ''
                  )}
                </form>
              </div>
            ) : (
              ''
            )}
          </div>
          {isNominatedUser ? (
            ''
          ) : (
            <button
              className="account-card account-card--new-payee account-card--noborder"
              onClick={this.showAddPayeePage}
              onKeyDown={this.checkKeyPress}
              tabIndex="0"
              type="button"
            >
              <div className="account-card--new-payee__content">
                {this.getSVGIcon()}
                {this.props.content.payNew}
              </div>
            </button>
          )}
          {this.showPayees()}
          {this.renderpayeeShowMoreButton()}
        </ul>
      </div>
    );
  }
}

PayeeListComponent.propTypes = {
  payeeList: PropTypes.object,
  payeeClass: PropTypes.string,
  content: PropTypes.object,
  onPayeeClick: PropTypes.func,
  showAddPayeePage: PropTypes.func,
  editClickFromPayee: PropTypes.func,
  deletePayeeClick: PropTypes.func,
};
PayeeListComponent.defaultProps = {
  payeeList: {},
  content: {},
  payeeClass: '',
  showAddPayeePage: PayeeListComponent.prototype.showAddPayeePage,
};

export default PayeeListComponent;
